import { useAppSelector } from '../../../../../../store/hooks';
import { getActiveMandantIdSelector } from '../../../../../shared/store/selectors/get-active-mandant-id/get-active-mandant-id.selector';
import { getIsAppLoadingSelector } from '../../../../../shared/store/selectors/get-is-app-loading/get-is-app-loading.selector';
import { AppTableModel } from '../../../../models/app-table.model';
import { getAppsTableFiltersSelector } from '../../../../store/selectors/get-apps-table-filters/get-apps-table-filters.selector';
import { getTableAppsSelector } from '../../../../store/selectors/get-table-apps/get-table-apps.selector';
import { AppsTableConfigModel } from './models/apps-table-config.model';

export const useGetAppsTableConfig = (): AppsTableConfigModel => {
  const tableRows: AppTableModel[] = useAppSelector(getTableAppsSelector);
  const isLoading = useAppSelector(getIsAppLoadingSelector);
  const activeMandantId = useAppSelector(getActiveMandantIdSelector);

  const appsFilters = useAppSelector(getAppsTableFiltersSelector);

  const appsHeaderFilters = appsFilters.header;
  const count = appsFilters.pagination.totalCount;
  const rowsPerPage = appsFilters.pagination.size;
  const page = appsFilters.pagination.pageNumber;

  return {
    tableRows,
    appsFilters,
    isLoading,
    activeMandantId,
    appsHeaderFilters,
    page,
    count,
    rowsPerPage,
  };
};
